export default [
  {
    path: 'recruit-hire-notice',
    name: 'RecruitHireNotice',
    meta: {
      isDynamic: true,
      id: '招募公告',
      inTab: true
    },
    component: () => import('@/views/RecruitHire/RecruitNoticeList/RecruitNoticeList.vue')
  },
  {
    path: 'save-recruit-hire-notice',
    name: 'SaveRecruitHireNotice',
    meta: {
      id: '编辑招募公告'
    },
    component: () => import('@/views/RecruitHire/SaveRecruitNotice/SaveRecruitNotice.vue')
  },
  {
    path: 'recruit-hire-apply',
    name: 'RecruitHireApply',
    meta: {
      isDynamic: true,
      id: '报名记录',
      inTab: true
    },
    component: () => import('@/views/RecruitHire/RecruitApplyList/RecruitApplyList.vue')
  },
  {
    path: 'recruit-hire-personnel',
    name: 'RecruitHirePersonnel',
    meta: {
      isDynamic: true,
      id: '资源池',
      inTab: true
    },
    component: () => import('@/views/RecruitHire/RecruitPersonnelList/RecruitPersonnelList.vue')
  },
  {
    path: 'recruit-hire-banner',
    name: 'RecruitHireBanner',
    meta: {
      isDynamic: true,
      id: '轮播图',
      inTab: true
    },
    component: () => import('@/views/RecruitHire/RecruitBannerList/RecruitBannerList.vue')
  }
];
